/**
 * Who a message is from, at a glance: the Tonnie mark for the platform, the
 * company's initials for a company. Decorative — the sender's name is always
 * written next to it, so the tile itself is hidden from assistive tech.
 */
import { TonnieLogo } from '@tonnie/assets';
import type { InboxSender } from '@tonnie/types';
import { cn } from '@tonnie/ui';

import { senderInitials } from '@tonnie/heroes';

interface SenderAvatarProps {
  sender: InboxSender;
  size?: 'sm' | 'md';
  className?: string;
}

export function SenderAvatar({ sender, size = 'sm', className }: SenderAvatarProps) {
  const box = size === 'md' ? 'h-11 w-11 text-sm' : 'h-9 w-9 text-xs';
  return (
    <span
      aria-hidden
      className={cn(
        'flex shrink-0 items-center justify-center rounded-full font-semibold',
        sender.kind === 'platform'
          ? 'bg-primary/10 dark:bg-primary/20'
          : 'bg-secondary text-secondary-foreground ring-1 ring-border/60',
        box,
        className
      )}
    >
      {sender.kind === 'platform' ? (
        <TonnieLogo variant="symbol" width={size === 'md' ? 24 : 20} />
      ) : (
        senderInitials(sender.name)
      )}
    </span>
  );
}
